<template>
  <div id="userDetails">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li>
          <a href="#/myusers">Manage Users</a>
        </li>
        <li class="active">
          <a>{{ user.title }} {{ user.last_name }}</a>
        </li>
      </ol>
    </div>
    <div class="content user-box middle">
      <div class="cell">
        <div class="container">
          <p class="sub-title text-center mb0">
            {{ user.title }}. {{ user.last_name }}
          </p>
          <p class="text-center gray">User Profile</p>

          <form class="form-horizontal mt50 mb50">
            <el-form :model="user" ref="userForm" status-icon :rules="rules" :validate-on-rule-change="false">
              <div class="form-group">
                <div v-if="this.userType == 'admin' && this.$store.state.user._id != this.user._id">
                  <label class="col-xs-2 control-label">Suspend user:</label>
                  <div class="col-xs-10" style="height:40px">
                    <el-tooltip :content="((suspendUser) ? 'Suspended' : 'Active')" placement="top">
                      <el-switch v-model="suspendUser" active-color="#ff4949" inactive-color="#13ce66"
                        :active-value="true" :inactive-value="false">
                      </el-switch>
                    </el-tooltip>
                  </div>
               </div>
                <label class="col-xs-2 control-label">Account type:</label>
                <div class="col-xs-4">
                  <el-select v-model="user.type" class="w100">
                    <el-option v-bind:key="type" v-for="type of userTypes" class="w100" :value="type"
                      :label="mapUserType(type)"></el-option>
                  </el-select>
                </div>
                <template v-if="userType == 'admin'">
                  <label class="col-xs-2 control-label">ERP-CustomerNo:</label>
                  <div class="col-xs-4">
                    <el-form-item prop="erp_customer_no">
                      <el-input v-model="user.erp_customer_no"></el-input>
                    </el-form-item>
                  </div>
                </template>
              </div>
              <div class="form-group">
                <label class="col-xs-2 control-label">Country:</label>
                <div class="col-xs-4">
                  <!-- <el-input v-model="user.country"></el-input> -->
                  <td>
                    <div class="el-input el-input--suffix">
                      <country-select class="el-input__inner" :country="user.country" v-model="user.country" />
                      <span class="el-input__suffix">
                        <span class="el-input__suffix-inner">
                          <i class="
                              el-select__caret
                              el-input__icon
                              el-icon-arrow-down
                            "></i>
                        </span>
                      </span>
                    </div>
                  </td>
                </div>
                <label class="col-xs-2 control-label">City:</label>
                <div class="col-xs-4">
                  <el-input v-model="user.city"></el-input>
                </div>
              </div>
              <div class="form-group">
                <label class="col-xs-2 control-label">Title:</label>
                <div class="col-xs-4">
                  <el-select v-model="user.title" class="w100">
                    <el-option label="Mr" value="Mr"></el-option>
                    <el-option label="Mrs" value="Mrs"></el-option>
                  </el-select>
                </div>
                <label class="col-xs-2 control-label">Preferred currency:</label>
                <div class="col-xs-4">
                  <el-select v-model="user.currency" class="w100">
                    <el-option label="USD" value="USD"></el-option>
                    <el-option label="EUR" value="EUR"></el-option>
                    <el-option label="CNY" value="CNY"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-xs-2 control-label">First name:</label>
                <div class="col-xs-4">
                  <el-input v-model="user.first_name"></el-input>
                </div>
                <label class="col-xs-2 control-label">Email:</label>
                <div class="col-xs-4">
                  <el-input v-model="user.email" :disabled="this.$store.state.user.type != 'admin'"></el-input>
                </div>
              </div>
              <div class="form-group">
                <label class="col-xs-2 control-label">Last name:</label>
                <div class="col-xs-4">
                  <el-input v-model="user.last_name"></el-input>
                </div>
                <label class="col-xs-2 control-label">Phone:</label>
                <div class="col-xs-4">
                  <el-input v-model="user.phone"></el-input>
                </div>
              </div>
              <div class="form-group">
                <label class="col-xs-2 control-label">Company:</label>
                <div class="col-xs-4">
                  <el-input v-model="user.company"></el-input>
                </div>
                <template v-if="user.type == 'distributors'">
                  <label class="col-xs-2 control-label">Color:</label>
                  <div class="col-xs-4">
                    <color-picker class="mr20 el-color-picker" v-model="user.color" :color="user.color" />
                  </div>
                </template>
              </div>
              <div class="form-group">
                <template v-if="userType == 'admin'">
                  <label class="col-xs-2 control-label">Barcode ID:</label>
                  <div class="col-xs-4">
                    <el-form-item prop="barcode_id">
                      <el-input v-model="user.barcode_id"></el-input>
                    </el-form-item>
                  </div>
                </template>
                <template v-if="user.type != 'admin' && userType == 'admin'">
                  <label class="col-xs-2 control-label">File Permissions:</label>
                  <div class="col-xs-4">
                    <el-checkbox-group v-model="user.checkedFilePermissions">
                      <el-checkbox class="black" v-for="permission in filePermissions" :label="permission"
                        :key="permission">{{ permission }}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                </template>
              </div>
              <div class="form-group" v-if="userType == 'admin'">
                <template>
                  <label class="col-xs-2 control-label"></label>
                  <div class="col-xs-4">
                  </div>
                </template>
                <template>
                  <label class="col-xs-2 control-label">Page Permissions:</label>
                  <div class="col-xs-4">
                    <el-checkbox-group v-model="user.checkedPagePermissions">
                      <el-checkbox class="black" v-for="permission in pagePermissions" :label="permission.value"
                        :key="permission.value">{{ permission.label }}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                </template>
              </div>
             <!--  <div class="form-group" v-if="userType == 'admin'">
                <template>
                  <label class="col-xs-2 control-label"></label>
                  <div class="col-xs-4">
                  </div>
                </template>
                <template>
                  <label class="col-xs-2 control-label">Configurator Permissions:</label>
                  <div class="col-xs-4">
                    <el-checkbox-group v-model="user.checkedConfiguratorPermissions">
                      <el-checkbox class="black" v-for="permission in configuratorPermissions" :label="permission"
                        :key="permission">{{ permission }}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                </template>
              </div> -->
              <div class="form-group" v-if="user.type == 'distributors'">
                <label class="col-xs-2 control-label">Logo:</label>
                <div class="col-xs-4">
                  <el-form-item class="white">
                    <el-input type="file" id="file" v-model="user.file_name" @input="handle_file_upload"></el-input>
                    <span style="color: black; font-size: 12px">Please upload PNG image 50x350px with transparent
                      background</span>
                    <div style="
                        height: 50px;
                        border: 1px solid #dcdfe6;
                        text-align: center;
                      " class="mt10">
                      <img style="width: 350px; max-height: 50px" id="preview" ref="preview" :src="thumbnail_url"
                        alt="your image" />
                    </div>
                    <a style="color: black" @click="removeLogo">Delete current logo</a>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group mt50">
                <!-- <div class="col-xs-2 col-xs-offset-3">
                          <el-button class="button1" > Activate </el-button>
              </div>-->
                <div class="col-xs-2 col-xs-offset-4">
                  <el-button class="button1" @click="edit_user()">Confirm and update</el-button>
                </div>
                <div class="col-xs-2">
                  <el-button class="button1" @click="
                    delete_user(
                      user._id,
                      user.first_name + ' ' + user.last_name
                    )
                    ">Delete account</el-button>
                </div>
              </div>
            </el-form>
          </form>
        </div>
      </div>
    </div>

    <div class="nav-footer white font16">
      <span class="click inlineb">
        <router-link class="white" to="/myusers">
          <i class="iconfont3 icon-back"></i> MANAGE USERS
        </router-link>
      </span>
    </div>
  </div>
</template>

<script>
import "@/assets/css/user.css";
import axios from "axios";
import ColorPicker from "../components/ColorPicker.vue";

export default {
  name: "userDetails",
  components: {
    ColorPicker,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.userType == "admin") {
        if (typeof value == "undefined" || value.length == 0) {
          callback(new Error("Barcode ID is required"));
        } else if (typeof value != "undefined" && value.length != 2) {
          callback(new Error("Please enter two characters"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      // configuratorPermissions: ["AXES/TT"],
      filePermissions: ["XLS", "JSON", "DXF", "CSV", "PDF"],
      pagePermissions: [
        {
          value: "SR",
          label: "Sales Resources"
        },
        {
          value: "TR",
          label: "Technical Resources"
        }, {
          value: "SP",
          label: "Sales Pipeline"
        }
      ],
      userTypes: [],
      user: {
        checkedFilePermissions: [],
        checkedPagePermissions: [],
        checkedConfiguratorPermissions: []
      },
      thumbnail_url: "",
      file: {},
      rules: {
        barcode_id: [{ validator: validatePass, trigger: ["blur"] }],
      },
      suspendUser: false,
      ignoreWatchOnSuspendUser: false
    };
  },
  methods: {
    setSuspendUserSilently(value) {
      this.ignoreWatchOnSuspendUser = true;
      this.suspendUser = value;
      this.$nextTick(() => {
        this.ignoreWatchOnSuspendUser = false;
      });
    },
    mapUserType(type) {
      return this.$store.state.userTypeMap[type];
    },
    removeLogo() {
      var c = confirm("Do you want to remove logo?");
      if (!c) return;
      axios.get("/user/remove-logo/" + this.$route.params.id).then(() => {
        this.file = {};
        this.user.file_name = "";
        this.$refs.preview.setAttribute("src", "");
      });
    },
    handle_file_upload() {
      var _this = this;
      this.file = document.getElementById("file").files[0];
      if (this.file.type != "image/png") {
        alert("Only .png image format!");
        _this.file = {};
        this.user.file_name = "";
        _this.$refs.preview.setAttribute("src", "");
        return false;
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          var height = this.height;
          var width = this.width;
          if (height > 50 || width > 350) {
            alert("Height and Width must not exceed 50x350px.");
            document.getElementById("file").value = "";
            _this.file = {};
            this.user.file_name = "";
            _this.$refs.preview.setAttribute("src", "");
            return false;
          }
          _this.$refs.preview.setAttribute("src", e.target.result);
        };
      };
      reader.readAsDataURL(this.file); // convert to base64 string
    },
    getData() {
      axios.get("/user/single/" + this.$route.params.id).then((response) => {
        if (typeof response.data.file_name != "undefined") {
          this.thumbnail_url =
            this.$store.state.serverURL +
            "/" +
            response.data.file_name +
            "?" +
            Date.now();
        }

        response.data.file_name = "";
        if (typeof response.data.checkedFilePermissions == 'undefined') {
          response.data.checkedFilePermissions = ["XLS", "JSON", "DXF", "CSV", "PDF"];
        }
        if (typeof response.data.checkedPagePermissions == 'undefined') {
          response.data.checkedPagePermissions = this.$store.state.defaultUserPagePrivilegies;
        }
        if (typeof response.data.checkedConfiguratorPermissions == 'undefined') {
          response.data.checkedConfiguratorPermissions = [];
        }
        this.user = response.data;
        
        if (typeof this.user.type == "undefined") this.user.type = "pending";
        if (typeof this.user.suspended != "undefined") {
          this.setSuspendUserSilently(this.user.suspended)
        }

      });
    },
    edit_user() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          let formData = new FormData();
          if (this.file instanceof File) {
            formData.append("file", this.file);
          }
          if (typeof this.user.created_by == "undefined") {
            this.user.created_by = this.$store.state.user._id;
          }
          for (var attr in this.user) {
            formData.append(attr, this.user[attr]);
          }
          axios
            .put("/user/" + this.user._id, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (res.data.ok == 1) {
                this.$message({
                  type: "success",
                  message: "Edited!",
                });
                this.$router.go(-1);
              } else {
                this.$message({
                  type: "error",
                  message: "Edit Failed!",
                });
              }
            })
            .catch(function (error) {
              alert(error);
            });
        }
      });
    },
    delete_user(ID, name) {
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE USER",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, name + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            axios
              .delete("/user/" + ID)
              .then((res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!",
                  });

                  this.$router.go(-1);
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch(function (error) {
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },
    async getUserTypes() {
      var response = await axios(
        "/user/usertypes/" + this.userType
      );
      this.userTypes = response.data;
    },
  },
  mounted() {
    this.getData();
    this.getUserTypes();
  },

  created: function () {
    this.$parent.headerBg();
    this.$parent.footerB();
  },
  computed: {
    userType: function () {
      if (this.$store.state.user != null) {
        return this.$store.state.user.type
      } else {
        return '';
      }
    },
  },
  watch: {
    suspendUser: function (value) {
      if (this.ignoreWatchOnSuspendUser) return;
      var type = (value) ? "warning" : "success";
      var q = (value) ? "suspended" : "active";
      
      axios
        .put("/user/" + this.user._id + "/suspend", {
          suspended : value
        })
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: type,
              message: "User is " + q + "!",
            });
          } else {
            this.$message({
              type: "error",
              message: "Save Failed!",
            });
          }
        })
        .catch(function (error) {
          alert(error);
        });

    },

  }
};
</script>
